import _ from 'lodash'
import * as Lib from '../constants/annotator'

// Half-window (in seconds) searched on each side of a click when snapping a
// beat marking to a local peak. 40 samples at 300 Hz in Turk V1; expressed here
// in seconds so the pixel-time search radius stays constant across sampling
// rates.
export const PEAK_SEARCH_HALF_WINDOW_SEC = 40 / 300

const square = (n) => n * n

// Given a click at (sampleIndex, yAmp) on a sample series, return the sample
// within a time-bounded window that minimizes pixel-space distance to the
// click. Amplitude and time are both weighted in *rendered pixels* — that's
// why PX_PER_MV and PX_PER_SECOND appear in the metric.
export const searchForLocalPeak = (sampleIndex, yAmp, samples, samplesPerSecond) => {
    // Defensive defaults: these values can occur before data is loaded / lead is selected.
    if (!Array.isArray(samples) || samples.length === 0 || !Number.isFinite(samplesPerSecond) || samplesPerSecond <= 0) {
        return { index: 0, sampleData: 0 }
    }

    const safeSampleIndex = Number.isFinite(sampleIndex) ? Math.round(sampleIndex) : 0
    const clampedSampleIndex = _.clamp(safeSampleIndex, 0, samples.length - 1)
    const safeYAmp = Number.isFinite(yAmp) ? yAmp : 0

    const windowWidth = Math.round(samplesPerSecond * PEAK_SEARCH_HALF_WINDOW_SEC)
    const lastIndex = samples.length - 1
    const startIndex = _.clamp(clampedSampleIndex - windowWidth, 0, lastIndex)
    const endIndex = _.clamp(clampedSampleIndex + windowWidth, 0, lastIndex)

    let minDiffVal2
    let minDiffIndex = startIndex
    for (let i = startIndex; i <= endIndex; i++) {
        const dy = Lib.PX_PER_MV * (safeYAmp - samples[i])
        const dx = (Lib.PX_PER_SECOND / samplesPerSecond) * (clampedSampleIndex - i)
        const diffVal2 = square(dy) + square(dx)
        if (minDiffVal2 === undefined || diffVal2 < minDiffVal2) {
            minDiffVal2 = diffVal2
            minDiffIndex = i
        }
    }
    return {
        index: minDiffIndex,
        sampleData: samples[minDiffIndex],
    }
}
